<div class="sticky z-2 bg-white glow-white" [style.top.px]="10">
    <div class="flex flex-row align-items-center">
        <app-page-heading class="flex-grow-1" title="Manage Catalog"></app-page-heading>
        <app-manage-catalog-actions #actions (onFormSubmitted)="form.onMarkFormAsDirty()"
            class="flex-grow-0"></app-manage-catalog-actions>
    </div>
</div>
<app-manage-catalog-form #form class="relative"></app-manage-catalog-form>